const ADD_FRUIT_TO_JAR = "fruitJar/ADD_FRUIT_TO_JAR";
const REMOVE_FRUIT_FROM_JAR = "fruitJar/REMOVE_FRUIT_FROM_JAR";
const CLEAR_FRUIT_JAR = "fruitJar/CLEAR_FRUIT_JAR";
const SET_LIMIT = "fruitJar/SET_LIMIT";

export { ADD_FRUIT_TO_JAR, REMOVE_FRUIT_FROM_JAR, CLEAR_FRUIT_JAR, SET_LIMIT };
